var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"flat":"","color":"white"}},[_c('content-dialog-component',{ref:"refContentDialogComponent"}),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }